import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField, SelectChangeEvent } from "@mui/material";
import { FilterList, FilterListOff } from "@mui/icons-material";
import { useState } from "react";

import { GenreFiltersStyle } from "../style";

import { GenreFilterBody } from "@/api/types/genre";

export const defaultValues: Omit<GenreFilterBody, "skip" | "take"> = { search: "", category: null };

// eslint-disable-next-line no-unused-vars
export default function GenreFilters({ onApply }: { onApply: (data: typeof defaultValues) => void }) {
    const [fields, setFields] = useState(defaultValues);
    const [filterActivated, setFilterActivated] = useState<boolean>(false);

    const toggleFilters = () => setFilterActivated((prev) => !prev);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | SelectChangeEvent) => {
        const name = event.target.name;
        const value = event.target.value;

        setFields((prev) => {
            return {
                ...prev,
                [name]: value,
            };
        });
    };

    const handleReset = () => {
        setFields(defaultValues);
        if (onApply) onApply(defaultValues);
    };

    const handleApply = () => onApply && onApply(fields);

    return (
        <GenreFiltersStyle>
            <Box className="filter-wrapper">
                {filterActivated && (
                    <>
                        <Box className="filter-fields-wrapper">
                            <TextField
                                className="input field "
                                label="Search"
                                name="search"
                                placeholder="Enter some text"
                                size="small"
                                value={fields.search}
                                onChange={handleChange}
                            />
                            <FormControl fullWidth className="select field" size="small">
                                <InputLabel id="select-label">Category</InputLabel>
                                <Select
                                    id="select"
                                    label="Category"
                                    labelId="select-label"
                                    name="category"
                                    value={String(fields.category)}
                                    onChange={handleChange}
                                >
                                    <MenuItem value={null as any}>All</MenuItem>
                                    <MenuItem value="education">Education</MenuItem>
                                    <MenuItem value="entertainment">Entertainment</MenuItem>
                                </Select>
                            </FormControl>
                            <Box className="actions">
                                <Button className="action-btn" variant="contained" onClick={handleApply}>
                                    Apply
                                </Button>
                                <Button className="action-btn" variant="contained" onClick={handleReset}>
                                    reset
                                </Button>
                            </Box>
                        </Box>
                    </>
                )}
            </Box>
            <Button
                startIcon={filterActivated ? <FilterListOff /> : <FilterList />}
                variant="contained"
                onClick={toggleFilters}
            >
                Filters
            </Button>
        </GenreFiltersStyle>
    );
}
